import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from '../../actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
const {
  GET_DASHBOARD_PATIENT_DETAILS_REQUEST,
  GET_DASHBOARD_PATIENT_DETAILS_SUCCESS,
  GET_DASHBOARD_PATIENT_DETAILS_FAILURE,
  GET_DASHBOARD_PATIENT_DETAILS_LOADER,
  GET_DASHBOARD_PATIENT_DETAILS_RESET,
} = DashboardConstants;

function* dashboardPatientInfo(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DASHBOARD_PATIENT_DETAILS_LOADER });
    const response = yield call(dashboardServices.getPatientDetails, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DASHBOARD_PATIENT_DETAILS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_PATIENT_DETAILS_FAILURE, payload: error });
  }
}

function* dashboardPatientInfoSaga() {
  yield takeEvery(GET_DASHBOARD_PATIENT_DETAILS_REQUEST, dashboardPatientInfo);
}

export default dashboardPatientInfoSaga;
